

export const USER_LOADING = 'USER_LOADING'
export const USER_LOADED = 'USER_LOADED'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'
export const GET_ERRORS = 'GET_ERRORS'
export const CLEAR_ERRORRS = 'CLEAR_ERRORS'
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS'
export const STUDENT_LOADING = 'STUDENT_LOADING'
export const STUDENT_SUCCESS = 'STUDENT_LOADED'
export const STUDENT_ADD_SUCCESS = 'STUDENT_ADD_SUCCESS'
export const STUDENT_DELETE_SUCCESS = 'STUDENT_DELETE_SUCCEESS'
export const STUDENT_EDIT_SUCCESS = 'STUDENT_EDIT_SUCCESS'
export const STUDENT_ERROR = 'STUDENT_ERROR'
export const DELETE_SUCCESS = 'DELETE_SUCCESS'
export const TEACHER_SUCCESS = 'TEACHER_LOADED'
export const TEACHER_ADD_SUCCESS = 'TEACHER_ADD_SUCCESS'
export const TEACHER_DELETE_SUCCESS = 'TEACHER_DELETE_SUCCEESS'
export const TEACHER_EDIT_SUCCESS = 'TEACHER_EDIT_SUCCESS'
export const TEACHER_ERROR = 'TEACHER_ERROR'
export const TEACHER_LOADING = 'TEACHER_LOADING'
export const BOOK_SUCCESS = 'BOOK_LOADED'
export const BOOK_ADD_SUCCESS = 'BOOK_ADD_SUCCESS'
export const BOOK_DELETE_SUCCESS = 'BOOK_DELETE_SUCCEESS'
export const BOOK_EDIT_SUCCESS = 'BOOK_EDIT_SUCCESS'
export const BOOK_ERROR = 'BOOK_ERROR'
export const BOOK_LOADING = 'BOOK_LOADING'
export const STUDENT_LENDING_TWO_SUCCESS = 'STUDENT_LENDING_SUCCESS'
export const TEACHER_LENDING_TWO_SUCCESS = 'TEACHER_LENDING_SUCCESS'
export const TEACHER_RETURN_SUCCESS = 'TEACHER_RETURN_SUCCESS'
export const STUDENT_RETURN_SUCCESS = 'STUDENT_RETURN_SUCCCESS'
export const STUDENT_BORROWERS_LIST = 'STUDENT_BORROWERS_LIST'
export const STUDENT_BORROWEDBOOKS_LIST = 'STUDENT_BORROWEDBOOKS_LIST'
export const TEACHER_BORROWERS_LIST = 'TEACHERS_BORROWERS_LIST'
export const TEACHER_BORROWEDBOOKS_LIST = 'TEACHER_BORROWEDBOOKS_LIST'
export const CHECK_LENDNG = 'CHECK_LENDING'
export const STUDENT_RECORDS_LIST = 'STUDENT_RECORDS_LIST'
export const TEACHER_RECORDS_LIST = 'TEACHER_RECORDS_LIST'
export const STUDENT_DELETE_BORROWER = 'STUDENT_DELETE_BORROWER'
export const TEACHER_DELETE_BORROWER = 'TEACHER_DELETE_BORROWER'
export const STUDENT_LIST_SEARCH = 'STUDENT_LIST_SEARCH'
export const STUDENT_BORROWERS_SEARCH = 'STUDENT_BORROWERS_SEARCH'
export const STUDENT_RECORDS_SEARCH = 'STUDENT_RECORDS_SEARCH'
export const STUDENT_BORROWEDBOOKS_SEARCH = 'STUDENT_BORROWEDBOOKS_SEARCH'
export const TEACHER_LIST_SEARCH = 'TEACHER_LIST_SEARCH'
export const TEACHER_BORROWERS_SEARCH = 'TEACHER_BORROWERS_SEARCH'
export const TEACHER_RECORDS_SEARCH = 'TEACHER_RECORDS_SEARCH'
export const TEACHER_BORROWEDBOOKS_SEARCH = 'TEACHER_BORROWEDBOOKS_SEARCH'
export const BOOKS_SEARCH = 'BOOKS_SEARCH'
export const CHECK_PASSWORD = 'CHECKPASSWORD'
export const CHANGE_PASSWORD = 'CHANGEPASSWORD'
export const CHANGE_EMAILORUSERNAME = 'CHANGEEMAILORUSERNAME'
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT'
export const DELETE_ACCOUNT_FAIL = 'DELETE_ACCOUNT_FAIL'
export const DELETE_ALL_TEACHERS = 'DELETE_ALL_TEACHERS'
export const DELETE_ALL_STUDENTS = 'DELETE_ALL_STUDENTS'
export const DELETE_ALL_TEACHER_BORROWERS = 'DELETE_ALL_TEACHER_BORROWERS'
export const DELETE_ALL_STUDENT_BORROWERS = 'DELETE_ALL_STUDENT_BORROWERS'
export const DELETE_ALL_STUDENT_RECORDS = 'DELETE_ALL_STUDENT_RECORDS'
export const DELETE_ALL_TEACHER_RECORDS = 'DELETE_ALL_TEACHER_RECORDS'
export const DELETE_ALL_BOOKS = 'DELETE_ALL_BOOKS'
export const PROMOTE_STUDENTS = 'PROMOTE_STUDENTS'
export const CHECK_PASSWORD_FAIL = 'CHECK_PASSWORD_FAIL'
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL'
export const CHANGE_EMAILORUSERNAME_FAIL = 'CHANGE_EMAILORUSERNAME_FAIL'
export const CLEAR_CONFIRMATION = 'CLEAR_CONFIRMATION'
export const RETURN_FOR_FINALIST = 'RETURN_FOR_FINALIST'
export const FINALIST_LIST = 'FINALIST_LIST'
export const DELETE_ALL_FINALISTS = 'DELETE_ALL_FINALISTS'
export const FINALISTS_SEARCH = 'FINALISTS_SEARCH'
export const DELETE_FINALIST = 'DELETE_FINALIST'
export const NETWORK_ERROR = 'NETWORK_ERROR'
export const NETWORK_SUCCESS = 'NETWORK_SUCCESS'
